import { ReactElement } from 'react';

import { Location as WaitlistLocation } from '@dreryk/egabinet-waitlist-frontend-api';

import { Select } from '@dreryk/react-components';
import { BindingCreator, createTranslatedText } from '@dreryk/react-common';

import { HealthcareProviderLocation } from '~libs.shared.healthcare-provider-location';

import { translationKeys } from '../../../translations';
import { WaitlistFormController } from '../../WaitlistForm.types';

import { formatVisitLocation } from './LocationField.utils';
import { LocationFieldLoader } from './LocationField.loader';

type LocationFormBeanPart = {
   location?: WaitlistLocation | null;
   videoConsultation: boolean;
};

type LocationFieldProps = Pick<WaitlistFormController, 'watch'> & {
   register: BindingCreator<LocationFormBeanPart>;
};

export const LocationField = (props: LocationFieldProps): ReactElement => {
   const currentVideoConsultation = props.watch('videoConsultation');
   return (
      <LocationFieldLoader>
         {({ locations }) => {
            return (
               <Select<HealthcareProviderLocation>
                  testId={'location'}
                  controller={props.register('location', {
                     required: !currentVideoConsultation,
                  })}
                  label={translationKeys.serviceProvidingLocation}
                  triggerLabelExtractor={formatVisitLocation}
                  placeholder={translationKeys.choosePlaceholder.ellipsified}
                  defaultValue={locations.length === 1 ? locations.at(0) : undefined}
               >
                  <Select.List items={locations} keyExtractor={'id'}>
                     {(item) => (
                        <Select.Item
                           testId={item.id.toString()}
                           item={item}
                           label={createTranslatedText(formatVisitLocation(item))}
                        />
                     )}
                  </Select.List>
               </Select>
            );
         }}
      </LocationFieldLoader>
   );
};
